import { Button as StandaloneButton } from '@/components/Button';
import { FrisbiiPaymentTheme } from '@/components/FrisbiiPayment/theme';
import { GenericSlot, GenericSlotFactory } from 'base/components/GenericSlot';

const $ = GenericSlotFactory({ theme: FrisbiiPaymentTheme });

const Base = $({ as: 'div', slot: 'base' });
const Content = $({ as: 'div', slot: 'content' });
const Caption = $({ as: 'span', slot: 'caption' });

const Button = GenericSlot({ as: StandaloneButton, theme: FrisbiiPaymentTheme.Button });

export const FrisbiiPayment = Object.assign(Base, {
  Content,
  Caption,
  Button,
});
